import { render, staticRenderFns } from "./LeftImageWithDescriptionSection.vue?vue&type=template&id=2c6b2e09"
import script from "./LeftImageWithDescriptionSection.vue?vue&type=script&lang=js"
export * from "./LeftImageWithDescriptionSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIImg: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/LORGAR/LORGAR_Deploy_Prod/components/ui/UIImg.vue').default,UIBulletedList: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/LORGAR/LORGAR_Deploy_Prod/components/ui/UIBulletedList.vue').default,AppContainer: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/LORGAR/LORGAR_Deploy_Prod/components/shared/AppContainer.vue').default,AppSection: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/LORGAR/LORGAR_Deploy_Prod/components/shared/AppSection.vue').default})
